export const LimitConfig = {
  LimitValueStartIndex: 10//FB44260-Pawan Prajapati
}
export class EntityBase {
  private __enmEntityState: DataEntityState = 0;
  public get EntityState(): DataEntityState {
    return this.__enmEntityState;
  }
  public set EntityState(value: DataEntityState) {
    this.__enmEntityState = value;
  }
}

export enum DataEntityState {
  Unchanged = 0,

  Added = 1,

  Modified = 2,

  Deleted = 3
}


export class DataEntity {
  public lDataEntityId: number;
  public DataEntity1: string;
  public Description: string;
}


export class User {
  public lUserId: number;
  public User1: string;
  public lDefaultTradingEntityId: number;
  public MarginCallLetterFromAddress: string;
  public MarginCallLetterSubject: string;
  public MarginCallLetterBody: string;
  public MarginCallLetterFromAddressPWD: string;
  public IsEnabled: number;
  public Password: string;
  public Email: string;
}



export class EntityGroupAudit {
  /*[Key]*/
  public lEntityGroupAuditId: number;
  public lEntityGroupId: number;
  public lDataEntityId: number;
  public DataEntity: DataEntity;
  public lDataEntityInstanceId: number;
  public lUserId: number;
  public UserName: string;
  public User: User;
  public dteDateTime: Date;
  public EntityGroup: EntityGroup;
}

export class EntityGroup {
  public lEntityGroupId: number;
  public EntityGroup1: string;
  public lPrimaryDataEntityId: number;
  public DataEntity: DataEntity;
  public IsEnableApproval: number;
  public IsEnableSearch: number;
  public lLookUpFieldNameId: number;
  public EntityGroupAudits: EntityGroupAudit[];
}

export class EntityGroupPrimaryEntity {//extends EntityBase
  public EntityGroupAudit: EntityGroupAudit;
}

export class CounterpartyLimitDataView extends EntityGroupPrimaryEntity {
  public lTradingLimitId: number;
  public lTradingCounterpartyId: number;
  public lOurEntityId: number;
  public lLimitTypeId: number;
  public lTradingCategoryId: number;
  public LimitValue: number;
  public lLimitValueCurrencyId: number;
  public lTenorTypeId: number;
  public StartPeriod: number;
  public Period: number;
  public lPeriodTypeId: number;
  public LimitStartDate: any;
  public LimitEndDate: any;
  public BUY: number;
  public SELL: number;
  public lTradingProductId: number;
  public lSubLimitTypeId: number;
  public lUnitId: number;
  public lUserId: number;
  public TradingCounterpartyName: string;
  public TradingCounterpartyEnabled: boolean;
  public TradingEntityName: string;
  public TradingEntityEnabled: boolean;
  public LimitTypeName: string;
  public LimitTypeTEEnabled: number;
  public SubLimitTypeName: string;
  public SubLimitTypeTEnabled: number;
  public TradingCategoryName: string;
  public TradingCategoryEnabled: number;
  public IsReadOnly: number;
  public lDefaultLimitCurrencyId: number;
  public CurrencyName: string;
  public TenorTypeName: string;
  public TenorTypeEnabled: number;
  public PeriodTypeName: string;
  public PeriodTypeEnabled: number;
  public TradingProductName: string;
  public TradingProductEnabled: number;
  public UnitName: string;
  public lParentTradingCounterpartyId: number;
  public UserNameFirstLetters: string;
  public MaxToDate: Date;
}

export class CounterpartyParentOwnership {
  public lCounterpartyParentOwnershipId: number;
  public lTradingCounterpartyId: number;
  public lParentTradingCounterpartyId: number;
  public OwnershipPercentage: number;
}

export class TradingCounterpartyLegalHierarchyOwnership {
  public IdentityColumn: number;
  public lLegalHierarchyTradingCounterpartyId: number;
  public lParentTradingCounterpartyId: number;
  public ParentTradingCounterparty: string;
  public lChildTradingCounterpartyId: number;
  public ChildTradingCounterparty: string;
  public IsChildrenHierarchy: number;
  public Level: number;
  public OwnershipPercentage: number;
  public Hierarchy: string;
  public HierarchyAlpha: string;
  public ParentCounterpartyEnabled: boolean;
  public ChildCounterpartyEnabled: boolean;
  public LegalCounterpartyEnabled: boolean;
}


export class CounterpartyLimitViewModel {
  public lCounterpartyLimitId: any;
  public lTradingCounterpartyId: number;
  public lOurEntityId: number;
  public lLimitTypeId: number;
  public lTradingCategoryId: number;
  public LimitValue: number;
  public lLimitValueCurrencyId: number;
  public lTenorTypeId: number;
  public StartPeriod: number;
  public Period: number;
  public lPeriodTypeId: number;
  public LimitStartDate: Date;
  public LimitEndDate: Date;
  public BUY: number;
  public SELL: number;
  public lTradingProductId: number;
  public lSubLimitTypeId: number;
  public lUnitId: number;
  public lUserId: number;
  public TradingCounterpartyName: string;
  public TradingCounterpartyEnabled: boolean;
  public TradingEntityName: string;
  public TradingEntityEnabled: boolean;
  public LimitTypeName: string;
  public LimitTypeTEEnabled: number;
  public SubLimitTypeName: string;
  public SubLimitTypeTEnabled: number;
  public TradingCategoryName: string;
  public TradingCategoryEnabled: number;
  public IsReadOnly: number;
  public lDefaultLimitCurrencyId: number;
  public CurrencyName: string;
  public TenorTypeName: string;
  public TenorTypeEnabled: number;
  public PeriodTypeName: string;
  public PeriodTypeEnabled: number;
  public TradingProductName: string;
  public TradingProductEnabled: number;
  public UnitName: string;
  public lParentTradingCounterpartyId: number;
  public From: any;
  public To: any;
  public lParentCounterpartyLimitId: any;
  public EntityState: number;
  public DataValues: DataValue[];
  public TempDataValues: DataValue[];
  Warnings: any[] = [];
  public IsEditButtonClicked: number;
  public IsLimitValueVaryingOverTime: boolean;
  public IsTempLimitValueVaryingOverTime: boolean;
  public TemporaryLimitFromDate?: Date;
  public TemporaryLimitToDate?: Date;
  public lTempLimitTenorTypeId: number;
  public TempLimitTenorTypeName: string;
  public RollingFromMonth: string;
  public RollingToMonth: string;
  public RollingFromPeriod: number;
  public RollingToPeriod: number;
  public IsTempLimitActive: boolean;
  public IsEditorEnabled: boolean = false;
  public IsOverall: number;
  public lParentTradingCategoryId: number;
  public TradingCategoryLevel: number;
  public CounterpartyLimitWarnings: any[] = [];
  public MaxToDate: any;
  public lParentTradingEntityId: number;
  public lTradingLimitCommentId: number;
  public TradingLimitComment: string;
  public TradingLimitCommentEntityState: number;
  public TradingCounterpartyLimit: TradingCounterpartyLimit;
  public LinkedLCPCGMessage: string;//FB44260-Pawan Prajapati
  public lCommodityCounterpartyLimitId: any;
  public lCommodityParentCounterpartyLimitId: any;
  public IsBuy: boolean;
  //Start FB46162-Pawan Prajapati
  public FourEyeRequestStatus: number;
  public FourEyeRequestTempStatus: number;
  public IsTempLimitAllocated: boolean;
  public IsNextRow: boolean;
  public IsTempLimitValueChanged: boolean;
  public IsLimitValueChanged: boolean;
  public PermanentLimitvalueDisabledMessage: string;
  public TempLimitvalueDisabledMessage: string;
  //End FB46162-Pawan Prajapati
  public lwfBusinessProcessInstanceId:number;//FB47640-Pawan Prajapati
  public IsEntityRestricted:boolean;//FB47392-Pawan Prajapati
  public CustomPropertyEntityState: number;//CRD-408-Pawan Prajapati
  public LimitCustomPropertyValues: LimitCustomPropertyValue[];//CRD-408-Pawan Prajapati
  public IsTradingCounterpartyInstanceSaveAccess: boolean;
  public IsReadonlyAccess: boolean;
}
export class DataValue {
  public lDataValueId: number;
  public OldLimitValue: any;//FB44260-Pawan Prajapati
  public lOverallLimitSettingId: number;//FB44260-Pawan Prajapati
  public LimitValue: any;
  public ColumnName: string;
  public lTradingLimitId: any;
  public IsVisible: boolean;
  public IsDisabled: boolean;
  public EntityState: number;
  public IsOverAllocation: number;
  public MaxAllocation: number;
  public OverAllLimitBreachAmount: number;
  Warnings: any[];
  ColourVariant: number;
  LimitValueCellBackgroundColour: string;
  TempDataValue: DataValue;
  public TempLimitStartDate: Date;
  public TempLimitEndDate: Date;
  public RollingHaltDate: Date;
  public IsLimitExpired: boolean;
  public IsCommodityOverAllocation: number;
  public UnVerifiedDataEntityWithFields: UnVerifiedDataEntityWithField[];//FB46162-Pawan Prajapati
}
//FB46162-Pawan Prajapati
export class UnVerifiedDataEntityWithField {
  AmendedBy: string;
  AmendedOn?: Date
  DataValue: string
  Status: number
  VerifiedBy: string
  VerifiedOn?: Date
  lAmendedById: number
  lDataEntityFieldNameId: number
  lDataEntityId: number
  lDataInstanceId: number
  lUnVerifiedDataEntityFieldId: number
  lUnVerifiedDataEntityId: number
  lVerifiedById?: number
}
export class PeriodDetail {
  public PeriodName: String;
  public StartDate: Date;
  public EndDate: Date;
  public LimitValue: number;
  public MaxLimitDetail: any[] = [];
  public MaxStartDate: Date;
  public MinStartDate: Date;
  public Color: string;
  public IsColorChanged: boolean;
  public RollingFromPeriod: number;
  public RollingToPeriod: number;
  public MinRollingFromPeriod: number;
  public MaxRollingFromPeriod: number;
  public MinRollingToPeriod: number;
  public MaxRollingToPeriod: number;
  public RollingFromPeriodSuspendValueChagned: false;
  public RollingToPeriodSuspendValueChagned: false;
}
export class MaxLimitAllocation {
  public MonthName: String;
  public EndMonthName: String;
  public MaxLimitAllocation: number;

}
export class TradingCounterpartyLimit {
  public lTradingCounterpartyId: number;

  public lOurEntityId: number;

  public lTradingCategoryId: number;

  public lLimitTypeId: number;

  public lLimitCurrencyId: number;

  public StartDate: Date;

  public EndDate: Date;

  public From: Date;//FB43617-Pawan Prajapati

  public To: Date;//FB43617-Pawan Prajapati

  public LimitValue: number;

  public lTradingCounterpartyLimitId: number;

  public lOverallLimitSettingId: number;

  public lLCPCGLinkedToLimitId: string;//FB42946-Pawan Prajapati

  public IsAutoRollOver: boolean;

  public LastReviewDate: Date;

  public NextReviewDate: Date;

  public ForwardLimitMonth: number;

  public EntityState: number;
  public TradingCounterpartyName: string;
  public TradingEntityName: string;
  public LimitTypeName: string;
  public IsEntityRestricted: boolean;
  public IsReadonlyAccess: boolean;
  public IsTradingCounterpartyInstanceSaveAccess: boolean;
}
//Start CRD-408-Pawan Prajapati
export class LimitCustomPropertyData {
  public lLimitCustomPropertyDataId: string;
  public lLimitCustomPropertyId: number;
  public LimitCustomProperty: string;
  public lLimitCustomPropertyDataTypeId: number;
  public Control: string;
  public LimitCustomPropertyItemSourceParameter: string;
  public DisplayOrder: number;
  public LimitCustomPropertyDataType: string;
  public FormatString: string;
  public Min: number;
  public Max: number;
  public TextSize: number;
  public Height: number;
  public ReferenceDataTextBoxVisible: number;
  public ReferenceDataURLVisible: number;
  public ItemSource: string[];
  public lCounterpartyLimitId: number;
  public Value: any;
  public DefaultValue: any;
}
export class LimitCustomPropertyValue {
  public lLimitCustomPropertyValueId: number;
  public lLimitCustomPropertyId: number
  public lTradingLimitId: number
  public Value: string;
}
//End CRD-408-Pawan Prajapati

//Start FB46162-Pawan Prajapati
export enum FourEyeStatus {
  Unchanged = 0,
  Added = 1,
  Modified = 2,
  Deleted = 3
}
//End FB46162-Pawan Prajapati
